module.exports = __webpack_public_path__ + "static/media/pilotOperation.da6c95d5.png";